import { render, staticRenderFns } from "./smDangerousGoods.vue?vue&type=template&id=3966b8c1&scoped=true&"
import script from "./smDangerousGoods.vue?vue&type=script&lang=js&"
export * from "./smDangerousGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3966b8c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3966b8c1')) {
      api.createRecord('3966b8c1', component.options)
    } else {
      api.reload('3966b8c1', component.options)
    }
    module.hot.accept("./smDangerousGoods.vue?vue&type=template&id=3966b8c1&scoped=true&", function () {
      api.rerender('3966b8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/smDangerousGoods.vue"
export default component.exports